import create from 'zustand';

export const DEV_FLAG_KEYS = [
  'onlyDevs',
  'isOnlyDevsAutomates',
  'isOnlyDevsExperience',
  'isOnlyDevsLogistics'
] as const;

export interface IState {
  onlyDevelopers: boolean;
  setOnlyDevelopers: (onlyDevelopers: boolean) => void;
  isOnlyDevsAutomates: boolean;
  setIsOnlyDevsAutomates: (isOnlyDevsAutomates: boolean) => void;
  isOnlyDevsExperience: boolean;
  setIsOnlyDevsExperience: (isOnlyDevsExperience: boolean) => void;
  isOnlyDevsLogistics: boolean;
  setIsOnlyDevsLogistics: (isOnlyDevsLogistics: boolean) => void;
}

const useOnlyDevelopers = create<IState>(set => ({
  onlyDevelopers: false,
  setOnlyDevelopers: onlyDevelopers => set({ onlyDevelopers }),
  isOnlyDevsAutomates: false,
  setIsOnlyDevsAutomates: isOnlyDevsAutomates => set({ isOnlyDevsAutomates }),
  isOnlyDevsExperience: false,
  setIsOnlyDevsExperience: isOnlyDevsExperience => set({ isOnlyDevsExperience }),
  isOnlyDevsLogistics: false,
  setIsOnlyDevsLogistics: isOnlyDevsLogistics => set({ isOnlyDevsLogistics })
}));

export default useOnlyDevelopers;
